import { Toaster } from "@/components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch, useLocation, Redirect } from "wouter";
import { useEffect } from "react";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Article from "./pages/Article";
import ArticleWhatToDo from "./pages/ArticleWhatToDo";
import ArticleRealEstate from "./pages/ArticleRealEstate";
import ServiceRealEstate from "./pages/ServiceRealEstate";
import ServiceCompanySetup from "./pages/ServiceCompanySetup";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import Services from "./pages/Services";
import ArticleCostOfLiving from "./pages/ArticleCostOfLiving";
import ArticleEntertainment from "./pages/ArticleEntertainment";
import ArticleCartierTransilvania from "./pages/ArticleCartierTransilvania";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ArticleBrasovVsEurope from "./pages/ArticleBrasovVsEurope";
import ArticleCompanySetup from "./pages/ArticleCompanySetup";
import ArticleBuyingApartment from "./pages/ArticleBuyingApartment";
import ArticleBuyPropertyAuctions from "./pages/ArticleBuyPropertyAuctions";
import ArticleBlackChurch from "./pages/ArticleBlackChurch";
import ArticleBrasovBusGuide from "./pages/ArticleBrasovBusGuide";
import ArticleWorkingRomania from "./pages/ArticleWorkingRomania";
import CookieBanner from "./components/CookieBanner";

// Scroll to top on every route change
function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location]);
  return null;
}

function Router() {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path={"/"} component={Home} />
        <Route path={"/why-expats-choose-brasov"} component={Article} />
        <Route path={"/what-to-do-in-brasov-city-guide"} component={ArticleWhatToDo} />
        <Route path={"/buying-apartment-brasov"} component={ArticleRealEstate} />
        <Route path={"/buying-apartment-brasov"}>{() => <Redirect to="/buying-apartment-brasov" />}</Route>
        {/* 301 redirects for old URLs */}
        <Route path={"/article"}>{() => <Redirect to="/why-expats-choose-brasov" />}</Route>
        <Route path={"/article-2"}>{() => <Redirect to="/what-to-do-in-brasov-city-guide" />}</Route>
        <Route path={"/article-3"}>{() => <Redirect to="/buying-apartment-brasov" />}</Route>
        <Route path={"/services/real-estate"} component={ServiceRealEstate} />
        <Route path={"/services/company-setup"} component={ServiceCompanySetup} />
        <Route path={"/about"} component={About} />
        <Route path={"/contact"} component={Contact} />
        <Route path={"/blog"} component={Blog} />
        <Route path={"/services"} component={Services} />
        <Route path={"/cost-of-living-brasov"} component={ArticleCostOfLiving} />
        <Route path={"/cost-of-living-brasov"}>{() => <Redirect to="/cost-of-living-brasov" />}</Route>
        <Route path={"/entertainment-brasov-guide"} component={ArticleEntertainment} />
        <Route path={"/cartier-transilvania-brasov"} component={ArticleCartierTransilvania} />
        {/* 301 redirects for old article- prefixed URLs */}
        <Route path={"/article-cost-of-living"}>{() => <Redirect to="/cost-of-living-brasov" />}</Route>
        <Route path={"/article-entertainment-brasov"}>{() => <Redirect to="/entertainment-brasov-guide" />}</Route>
        <Route path={"/article-cartier-transilvania"}>{() => <Redirect to="/cartier-transilvania-brasov" />}</Route>
        <Route path={"/brasov-vs-budapest-prague-vienna-expats"} component={ArticleBrasovVsEurope} />
        <Route path={"/company-setup-romania"} component={ArticleCompanySetup} />
        <Route path={"/company-setup-romania"}>{() => <Redirect to="/company-setup-romania" />}</Route>
        <Route path={"/buying-apartment-foreigner-brasov"} component={ArticleBuyingApartment} />
        <Route path={"/buying-apartment-foreigner-brasov"}>{() => <Redirect to="/buying-apartment-foreigner-brasov" />}</Route>
        <Route path={"/buy-property-romania-auctions-seized-assets"} component={ArticleBuyPropertyAuctions} />
        <Route path={"/black-church-brasov-visitor-guide"} component={ArticleBlackChurch} />
        <Route path={"/brasov-bus-guide"} component={ArticleBrasovBusGuide} />
        <Route path={"/working-in-romania-foreigner-guide"} component={ArticleWorkingRomania} />
        <Route path={"/privacy-policy"} component={PrivacyPolicy} />
        <Route path={"/404"} component={NotFound} />
        {/* Final fallback route */}
        <Route component={NotFound} />
      </Switch>
    </>
  );
}

// NOTE: About Theme
// - First choose a default theme according to your design style (dark or light bg), than change color palette in index.css
//   to keep consistent foreground/background color across components
// - If you want to make theme switchable, pass `switchable` ThemeProvider and use `useTheme` hook

function App() {
  return (
    <HelmetProvider>
    <ErrorBoundary>
      <ThemeProvider
        defaultTheme="light"
        // switchable
      >
        <TooltipProvider>
          <Toaster />
          <Router />
          <CookieBanner />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
